<span *ngIf="!loadingBenchmarks && timePeriod?.value !== 'none'">
  <span
    class="benchmark"
    [ngClass]="benchmarkClassName"
    [pTooltip]="tooltip"
    tooltipStyleClass="comparison-date-tooltip"
    tooltipPosition="left"
    *ngIf="benchmark; else noBenchmark"
  >
    <i
      [ngClass]="benchmark > 0 ? 'up' : 'down'"
      class="icon caret"
    ></i>
    <ng-container *ngIf="displayAs === 'percentages'">&ngsp;{{abs(benchmark) | percent:percentOptions}}</ng-container>
    <ng-container *ngIf="displayAs === 'values'">&ngsp;{{abs(difference) | format:differenceFormat}}</ng-container>
    <ng-container *ngIf="displayAs === 'both'"
      >&ngsp;{{abs(benchmark) | percent:percentOptions}} ({{abs(difference) | format:differenceFormat}})</ng-container
    >
  </span>
  <ng-template #noBenchmark>
    <span class="benchmark">n/a</span>
  </ng-template>
</span>
<div *ngIf="timePeriod && timePeriod?.value !== 'none' && loadingBenchmarks" class="ui tiny active inline loader"></div>
